import {
  useShowController,
  TextField,
  DateField,
  ReferenceField,
  useRedirect,
} from 'react-admin';
import { useParams } from 'react-router-dom';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  LinearProgress,
  Box,
  Button,
} from '@mui/material';
import palette from '../../theme/palette';

const LogDetail = () => {
  const { id } = useParams();
  const { record, isLoading } = useShowController({ resource: 'records', id });
  const redirect = useRedirect();

  if (isLoading || !record) {
    return (
      <LinearProgress />
    );
  }

  return (
    <Card variant="elevation">
      <CardContent>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant="h5" gutterBottom>Patrol Details</Typography>
          <Button
            className='white-outlined-button'
            onClick={() => { redirect('list', 'logs') }}
          >
            Back
          </Button>
        </Box>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><b>Site</b></TableCell>
                <TableCell><b>Route</b></TableCell>
                <TableCell><b>MODIFIED TIME</b></TableCell>
                <TableCell><b>Operator</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell><TextField source="schedule.route.site.name" record={record} /></TableCell>
                <TableCell><TextField source="schedule.route.name" record={record} /></TableCell>
                <TableCell><DateField source="updatedAt" record={record} showTime /></TableCell>
                <TableCell>
                  <ReferenceField label="Operator" reference="cognitoUsers" source="operator_id" record={record}>
                    <TextField source="name" style={{ color: 'white'}} />
                  </ReferenceField>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography variant="h6" gutterBottom>Checkpoints & Checklist</Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: palette.background.paper }}>
              <TableRow>
                <TableCell>NO</TableCell>
                <TableCell>CHECKPOINT</TableCell>
                <TableCell>CHECKLIST</TableCell>
                <TableCell>NOTES</TableCell>
                <TableCell>SNAPSHOT</TableCell>
                <TableCell>INCIDENTS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {record?.checkpoint_records.items.length > 0 ? (
                record?.checkpoint_records.items.map((chrecord, index) => {
                  const checklistItems = JSON.parse(chrecord.checklist_results)?.items || [];
                  return (
                    <TableRow key={chrecord.id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{chrecord?.checkpoint?.name}</TableCell>
                      <TableCell>
                        {checklistItems.map((check, i) => (
                          <Typography key={i}>
                            {check?.checked ? '✔' : '✖'} {check?.item}
                          </Typography>
                        ))}
                      </TableCell>
                      <TableCell>{chrecord?.notes || '-'}</TableCell>
                      <TableCell>
                        {chrecord.image_url ? (
                          <Box
                            component="img"
                            src={chrecord?.image_url || ""}
                            alt="Snapshot"
                            width={80}
                          />
                        ) : '-'}
                      </TableCell>
                      <TableCell>{chrecord?.incident_type?.name || '-'}</TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography>No data</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default LogDetail;
export { LogDetail };